/**
 * Market Form Configuration
 * 
 * Defines form field labels, validation rules, and field types for each market/country
 */

window.MarketFormConfig = {
  // Country name to ISO code mapping
  countryMap: {
    'United Arab Emirates': 'AE',
    'Saudi Arabia': 'SA',
    'United Kingdom': 'GB',
    'Singapore': 'SG',
    'United States': 'US',
    'India': 'IN',
    'France': 'FR',
    'Germany': 'DE',
    'Italy': 'IT',
    'Spain': 'ES',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Switzerland': 'CH',
    'Sweden': 'SE',
    'Norway': 'NO',
    'Denmark': 'DK',
    'Finland': 'FI',
    'Portugal': 'PT',
    'Ireland': 'IE',
    'Austria': 'AT',
    'Poland': 'PL',
    'Greece': 'GR',
    'Czech Republic': 'CZ',
    'Romania': 'RO',
    'Hungary': 'HU',
    'Bulgaria': 'BG',
    'Croatia': 'HR',
    'Cyprus': 'CY',
    'Estonia': 'EE',
    'Latvia': 'LV',
    'Lithuania': 'LT',
    'Luxembourg': 'LU',
    'Malta': 'MT',
    'Slovakia': 'SK',
    'Slovenia': 'SI'
  },

  // Form configuration for each market
  formConfigs: {
    'UAE': {
      countryName: 'United Arab Emirates',
      countryCode: 'AE',
      phoneCountryCode: '+971',
      stateLabel: 'Emirate',
      stateFieldType: 'select',
      stateOptions: [
        { value: 'Abu Dhabi', label: 'Abu Dhabi' },
        { value: 'Dubai', label: 'Dubai' },
        { value: 'Sharjah', label: 'Sharjah' },
        { value: 'Ajman', label: 'Ajman' },
        { value: 'Umm Al Quwain', label: 'Umm Al Quwain' },
        { value: 'Ras Al Khaimah', label: 'Ras Al Khaimah' },
        { value: 'Fujairah', label: 'Fujairah' }
      ],
      postalCodeRequired: false,
      postalCodeLabel: 'Postal code',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'Saudi Arabia': {
      countryName: 'Saudi Arabia',
      countryCode: 'SA',
      phoneCountryCode: '+966',
      stateLabel: 'Province',
      stateFieldType: 'select',
      stateOptions: [
        { value: 'Riyadh', label: 'Riyadh' },
        { value: 'Makkah', label: 'Makkah' },
        { value: 'Madinah', label: 'Madinah' },
        { value: 'Eastern Province', label: 'Eastern Province' },
        { value: 'Al Qassim', label: 'Al Qassim' },
        { value: 'Asir', label: 'Asir' },
        { value: 'Tabuk', label: 'Tabuk' },
        { value: 'Hail', label: 'Hail' },
        { value: 'Northern Borders', label: 'Northern Borders' },
        { value: 'Jazan', label: 'Jazan' },
        { value: 'Najran', label: 'Najran' },
        { value: 'Al Bahah', label: 'Al Bahah' },
        { value: 'Al Jawf', label: 'Al Jawf' }
      ],
      postalCodeRequired: true,
      postalCodeLabel: 'Postal code',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'UK': {
      countryName: 'United Kingdom',
      countryCode: 'GB',
      phoneCountryCode: '+44',
      stateLabel: 'County',
      stateFieldType: 'text',
      stateOptions: [],
      postalCodeRequired: true,
      postalCodeLabel: 'Postcode',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'Singapore': {
      countryName: 'Singapore',
      countryCode: 'SG',
      phoneCountryCode: '+65',
      stateLabel: 'Region',
      stateFieldType: 'text',
      stateOptions: [],
      postalCodeRequired: true,
      postalCodeLabel: 'Postal code',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'USA': {
      countryName: 'United States',
      countryCode: 'US',
      phoneCountryCode: '+1',
      stateLabel: 'State',
      stateFieldType: 'select',
      stateOptions: [
        { value: 'AL', label: 'Alabama' },
        { value: 'AK', label: 'Alaska' },
        { value: 'AZ', label: 'Arizona' },
        { value: 'AR', label: 'Arkansas' },
        { value: 'CA', label: 'California' },
        { value: 'CO', label: 'Colorado' },
        { value: 'CT', label: 'Connecticut' },
        { value: 'DE', label: 'Delaware' },
        { value: 'FL', label: 'Florida' },
        { value: 'GA', label: 'Georgia' },
        { value: 'HI', label: 'Hawaii' },
        { value: 'ID', label: 'Idaho' },
        { value: 'IL', label: 'Illinois' },
        { value: 'IN', label: 'Indiana' },
        { value: 'IA', label: 'Iowa' },
        { value: 'KS', label: 'Kansas' },
        { value: 'KY', label: 'Kentucky' },
        { value: 'LA', label: 'Louisiana' },
        { value: 'ME', label: 'Maine' },
        { value: 'MD', label: 'Maryland' },
        { value: 'MA', label: 'Massachusetts' },
        { value: 'MI', label: 'Michigan' },
        { value: 'MN', label: 'Minnesota' },
        { value: 'MS', label: 'Mississippi' },
        { value: 'MO', label: 'Missouri' },
        { value: 'MT', label: 'Montana' },
        { value: 'NE', label: 'Nebraska' },
        { value: 'NV', label: 'Nevada' },
        { value: 'NH', label: 'New Hampshire' },
        { value: 'NJ', label: 'New Jersey' },
        { value: 'NM', label: 'New Mexico' },
        { value: 'NY', label: 'New York' },
        { value: 'NC', label: 'North Carolina' },
        { value: 'ND', label: 'North Dakota' },
        { value: 'OH', label: 'Ohio' },
        { value: 'OK', label: 'Oklahoma' },
        { value: 'OR', label: 'Oregon' },
        { value: 'PA', label: 'Pennsylvania' },
        { value: 'RI', label: 'Rhode Island' },
        { value: 'SC', label: 'South Carolina' },
        { value: 'SD', label: 'South Dakota' },
        { value: 'TN', label: 'Tennessee' },
        { value: 'TX', label: 'Texas' },
        { value: 'UT', label: 'Utah' },
        { value: 'VT', label: 'Vermont' },
        { value: 'VA', label: 'Virginia' },
        { value: 'WA', label: 'Washington' },
        { value: 'WV', label: 'West Virginia' },
        { value: 'WI', label: 'Wisconsin' },
        { value: 'WY', label: 'Wyoming' }
      ],
      postalCodeRequired: true,
      postalCodeLabel: 'ZIP code',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'Europe': {
      countryName: 'France', // Default for Europe
      countryCode: 'FR',
      phoneCountryCode: '+33',
      stateLabel: 'Region',
      stateFieldType: 'text',
      stateOptions: [],
      postalCodeRequired: true,
      postalCodeLabel: 'Postal code',
      addressLabel: 'Address',
      cityLabel: 'City'
    },
    'INR': {
      countryName: 'India',
      countryCode: 'IN',
      phoneCountryCode: '+91',
      stateLabel: 'State',
      stateFieldType: 'text',
      stateOptions: [],
      postalCodeRequired: true,
      postalCodeLabel: 'PIN code',
      addressLabel: 'Address',
      cityLabel: 'City'
    }
  },

  /**
   * Get form configuration for a market
   * @param {string} market - Market name (e.g., 'UAE', 'UK', 'USA')
   * @returns {Object} Form configuration
   */
  getFormConfig: function(market) {
    return this.formConfigs[market] || this.formConfigs['UAE'];
  },

  /**
   * Get all available countries for dropdown
   * @returns {Array} Array of country objects
   */
  getAvailableCountries: function() {
    return [
      { name: 'United Arab Emirates', code: 'AE' },
      { name: 'Saudi Arabia', code: 'SA' },
      { name: 'United Kingdom', code: 'GB' },
      { name: 'Singapore', code: 'SG' },
      { name: 'United States', code: 'US' },
      { name: 'India', code: 'IN' },
      { name: 'France', code: 'FR' },
      { name: 'Germany', code: 'DE' },
      { name: 'Italy', code: 'IT' },
      { name: 'Spain', code: 'ES' },
      { name: 'Netherlands', code: 'NL' },
      { name: 'Belgium', code: 'BE' },
      { name: 'Switzerland', code: 'CH' },
      { name: 'Sweden', code: 'SE' },
      { name: 'Norway', code: 'NO' },
      { name: 'Denmark', code: 'DK' },
      { name: 'Finland', code: 'FI' },
      { name: 'Portugal', code: 'PT' },
      { name: 'Ireland', code: 'IE' },
      { name: 'Austria', code: 'AT' },
      { name: 'Poland', code: 'PL' },
      { name: 'Greece', code: 'GR' },
      { name: 'Czech Republic', code: 'CZ' },
      { name: 'Romania', code: 'RO' },
      { name: 'Hungary', code: 'HU' },
      { name: 'Bulgaria', code: 'BG' },
      { name: 'Croatia', code: 'HR' },
      { name: 'Cyprus', code: 'CY' },
      { name: 'Estonia', code: 'EE' },
      { name: 'Latvia', code: 'LV' },
      { name: 'Lithuania', code: 'LT' },
      { name: 'Luxembourg', code: 'LU' },
      { name: 'Malta', code: 'MT' },
      { name: 'Slovakia', code: 'SK' },
      { name: 'Slovenia', code: 'SI' }
    ];
  }
};

